var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-footer"},[_c('p',[_vm._v("Copyright © 2024 柏悦众诚模板展示中心 All Rights Reserved.")]),_c('a',{staticClass:"beian",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("京ICP备20012597号")])])
}]

export { render, staticRenderFns }